import { http } from './config'

export default {
    listar: () => {
        return http.get('/v1/empresas')
    },
    salvar: (data) => {
        return http.post('/v1/empresas', data)
    },
    editar: (id) => {
        return http.get(`/v1/empresas/${id}`)
    },
    atualizar: (data) => {
        return http.put(`/v1/empresas/${data.id}`, data)
    },
    excluir: (id) => {
        return http.delete(`/v1/empresas/${id}`)
    },
    uploadCertificado: (data) => {
        return http.post(`/v1/empresa/certificado/upload`, data)
    },
    salvarLogo: (data, id) => {
        return http.post(`/v1/empresa/${id}/logo/salvar`, data)
    }
    
}